import { useTranslation } from "react-i18next";
import { BellRing } from "lucide-react";
import AdminLayout from "@/components/admin/AdminLayout";
import { AlertRulesTable } from "@/components/admin/inventory/AlertRulesTable";

// ---------------------------------------------------------------------------
// Page component
// ---------------------------------------------------------------------------

export default function StockAlerts() {
  const { t } = useTranslation("admin");

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Page header */}
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-100 text-amber-700">
            <BellRing className="h-5 w-5" />
          </div>
          <div>
            <h1 className="font-display text-xl font-semibold text-stone-900">
              {t("stock_alerts.page_title", "Alertes de stock")}
            </h1>
            <p className="text-sm text-stone-500">
              {t(
                "stock_alerts.page_subtitle",
                "Configurez des seuils d'alerte et des notifications automatiques",
              )}
            </p>
          </div>
        </div>

        {/* Rules table (manages its own "Ajouter une règle" button + modal) */}
        <AlertRulesTable />
      </div>
    </AdminLayout>
  );
}
